function UPDATE_GLOBAL_PARAMS (state, payload) {
  state.globalParams = payload
}
function UPDATE_ACQUISITIOIN_INFO (state, payload) {
  state.acquisitionInfo = payload
}
function UPDATE_PARTICIPATE_INFO (state, payload) {
  state.participateInfo = payload
}
function UPDATE_PROMO_RESULT (state, payload) {
  state.promoResult = payload
}
function UPDATE_PAYINFO (state, payload) {
  state.payInfo = payload
}
function UPDATE_SELECTED_PAYMENT (state, payload) {
  state.selectedCard = payload
}
function UPDATE_EXTRAINFO_LIST (state, payload) {
  state.extraInfoList = payload
}
export default {
  UPDATE_GLOBAL_PARAMS,
  UPDATE_ACQUISITIOIN_INFO,
  UPDATE_PARTICIPATE_INFO,
  UPDATE_PROMO_RESULT,
  UPDATE_PAYINFO,
  UPDATE_SELECTED_PAYMENT,
  UPDATE_EXTRAINFO_LIST
}
